import {
  AccountBox,
  AdminPanelSettings,
  Logout,
  PlayArrow,
  SignpostOutlined,
  Work,
} from "@mui/icons-material";

import MenuIcon from "@mui/icons-material/Menu";
import WorkIcon from "@mui/icons-material/Work";
import { PersonOutline } from "@mui/icons-material";
import PersonRoundedIcon from "@mui/icons-material/PersonRounded";
import { HandymanOutlined } from "@mui/icons-material";
import { Link } from "@mui/icons-material";
import { Login } from "@mui/icons-material";
import { keyframes } from "@mui/system";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import CloseIcon from "@mui/icons-material/Close";
import InstallMobileIcon from "@mui/icons-material/InstallMobile";
import AndroidIcon from "@mui/icons-material/Android";
import AppleIcon from "@mui/icons-material/Apple";

import {
  ThemeProvider,
  alpha,
  createTheme,
  styled,
} from "@mui/material/styles";

import HomeIcon from "@mui/icons-material/Home";
import {
  AppBar,
  Avatar,
  Box,
  Button,
  IconButton,
  InputBase,
  ListItemIcon,
  Menu,
  MenuItem,
  Stack,
  Toolbar,
  Tooltip,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import axios from "axios";
import Cookies from "js-cookie";
import React, { useEffect, useState } from "react";
import { NavLink, Navigate } from "react-router-dom";
import logo from "../asset/images/logo.png";
import PositionedMenu from "./PositionedMenu";
import YouTubeIcon from "@mui/icons-material/YouTube";
import { useLocation } from "react-router-dom";
/** שמור על הסכמת העוגיות בלוקאל סטורג' במהלך Logout */
const PRESERVE_LOCAL_KEYS = ["bidit.cookieConsent"];
function clearLocalStorageExcept(keep = []) {
  try {
    const keepSet = new Set(keep);
    const toRemove = [];
    for (let i = 0; i < localStorage.length; i++) {
      const k = localStorage.key(i);
      if (k && !keepSet.has(k)) toRemove.push(k);
    }
    toRemove.forEach((k) => localStorage.removeItem(k));
  } catch {}
}

function Navbar() {
  const { pathname } = useLocation();

  const isBlogPage = pathname === "/blog" || pathname.startsWith("/blog/");
  const isHomePage = pathname === "/" || pathname === "/home";
  const [content, setContent] = useState([]);
  const [auto, setAuto] = useState(false);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [notifications, setNotifications] = useState([]);
  const [badgeContent, setBadgeContent] = useState(0);
  const [showNotifications, setShowNotifications] = useState(false);

  // כתובת החנות לאנדרואיד
  const PLAY_URL =
    "https://play.google.com/store/apps/details?id=dev.expo.bidit&hl=he";

  // זיהוי פלטפורמה
  const ua = typeof navigator !== "undefined" ? navigator.userAgent || "" : "";
  const isAndroid = /Android/i.test(ua);
  const isIOS = /iPhone|iPad|iPod/i.test(ua);
  const isSafari = /^((?!chrome|android).)*safari/i.test(ua);
  const isiOSSafari = isIOS && isSafari;

  // מצב התקנה כתצוגה עצמאית
  const [isStandalone, setIsStandalone] = useState(false);
  const [openIOSHelp, setOpenIOSHelp] = useState(false);

  // בסיס ה-API והכנת כותרות
  const API_BASE = process.env.React_APP_BACKEND_URL || "";
  const getAuthHeaders = () => {
    const token = Cookies.get("token") || "";
    return token ? { Authorization: "Bearer " + token } : {};
  };

  // פונקציה מרוכזת למשיכת התראות
  const fetchNotifications = () => {
    const userId = Cookies.get("id");
    if (!userId) return;
    const idParam = encodeURIComponent(userId);
    axios
      .get(API_BASE + "/api/getnotifications?id=" + idParam, {
        headers: getAuthHeaders(),
      })
      .then((res) => {
        setContent(
          res.data.Content && res.data.Content[0] ? res.data.Content[0] : {},
        );
        setNotifications(res.data.Notifications || []);
        setBadgeContent(res.data.TotalNoti || 0);
        setShowNotifications(true);
      })
      .catch((err) => {
        console.log(err);
        const fallback =
          err &&
          err.response &&
          err.response.data &&
          err.response.data.Content &&
          err.response.data.Content[0]
            ? err.response.data.Content[0]
            : {};
        setContent(fallback);
      });
  };

  useEffect(() => {
    const standaloneWeb =
      window.matchMedia &&
      window.matchMedia("(display-mode: standalone)").matches;
    const standaloneIOS = window.navigator.standalone === true;
    setIsStandalone(Boolean(standaloneWeb || standaloneIOS));
  }, []);

  useEffect(() => {
    fetchNotifications();
  }, []);

  useEffect(() => {
    const interval = setInterval(
      () => {
        fetchNotifications();
      },
      2 * 60 * 1000,
    );
    return () => clearInterval(interval);
  }, []);

  const [menuOpen, setMenuOpen] = useState(true);
  const [shown, setIsShown] = useState(false);
  const [open, setOpen] = useState(false);

  const StyledToolbar = styled(Toolbar)(({ theme }) => ({
    display: "flex",
    margin: "0px",
    justifyContent: "space-between",
    gap: theme.spacing(1),
    paddingInline: theme.spacing(1.5),
    fontFamily: `${process.env.REACT_APP_FONT}`,
    fontWeight: "bold",
    minHeight: 62,
    [theme.breakpoints.up("sm")]: {
      minHeight: 74,
      paddingInline: theme.spacing(2.5),
    },
  }));

  const Search = styled("div")(({ theme }) => ({
    position: "relative",
    fontFamily: `${process.env.REACT_APP_FONT}`,
    fontWeight: "bold",
    borderRadius: theme.shape.borderRadius,
    backgroundColor: alpha(theme.palette.common.white, 0.15),
    "&:hover": { backgroundColor: alpha(theme.palette.common.white, 0.25) },
    marginLeft: 0,
    width: { display: { xs: "50%", md: "100%" } },
    [theme.breakpoints.up("sm")]: {
      marginLeft: theme.spacing(1),
      width: "auto",
    },
  }));

  const SearchIconWrapper = styled("div")(({ theme }) => ({
    padding: theme.spacing(0, 2),
    height: "100%",
    position: "absolute",
    pointerEvents: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontFamily: `${process.env.REACT_APP_FONT}`,
    fontWeight: "bold",
  }));

  const pulseOnBlue = keyframes`
  0%   { box-shadow: 0 0 0 2px #fff, 0 0 0 6px rgba(255,255,255,0), 0 2px 4px rgba(0,0,0,.12) }
  50%  { box-shadow: 0 0 0 2px #fff, 0 0 0 12px rgba(255,255,255,.55), 0 4px 10px rgba(0,0,0,.14) }
  100% { box-shadow: 0 0 0 2px #fff, 0 0 0 6px rgba(255,255,255,0), 0 2px 4px rgba(0,0,0,.12) }
  `;

  const StyledInputBase = styled(InputBase)(({ theme }) => ({
    color: "inherit",
    "& .MuiInputBase-input": {
      padding: theme.spacing(1, 1, 1, 0),
      fontFamily: `${process.env.REACT_APP_FONT}`,
      fontWeight: "bold",
      paddingLeft: `calc(1em + ${theme.spacing(4)})`,
      transition: theme.transitions.create("width"),
      width: "100%",
      [theme.breakpoints.up("sm")]: { width: "20ch" },
    },
  }));

  const BoxStyled = styled(Box)(({ theme }) => ({
    display: "none",
    justifyContent: "space-between",
    gap: "10px",
    fontFamily: `${process.env.REACT_APP_FONT}`,
    fontWeight: "bold",
    alignItems: "center",
    [theme.breakpoints.up("md")]: { display: "flex" },
  }));

  const UserBox = styled(Box)(({ theme }) => ({
    display: "flex",
    fontFamily: `${process.env.REACT_APP_FONT}`,
    fontWeight: "bold",
    justifyContent: "space-between",
    gap: "20px",
    alignItems: "center",
    [theme.breakpoints.up("md")]: { display: "none" },
  }));

  const AppBar1 = styled(AppBar)(({ theme }) => ({
    position: "sticky",
    width: "100%",
    fontFamily: `${process.env.REACT_APP_FONT}`,
    fontWeight: "bold",
  }));

  const [anchorEl1, setAnchorEl1] = React.useState(null);
  const open1 = Boolean(anchorEl1);
  const handleClick = (event) => setAnchorEl1(event.currentTarget);
  const [showResult, setShowResult] = useState(false);
  const [search1, setSearch] = useState("");
  const handleClose = () => setAnchorEl1(null);

  const burgerPulse = keyframes`
  0%   { box-shadow: 0 0 0 2px white, 0 0 0 6px #2196F3, 0 2px 4px rgba(0,0,0,.12), 0 4px 8px rgba(0,0,0,.12) }
  70%  { box-shadow: 0 0 0 2px white, 0 0 0 14px rgba(33,150,243,0), 0 2px 4px rgba(0,0,0,.12), 0 4px 8px rgba(0,0,0,.12) }
  100% { box-shadow: 0 0 0 2px white, 0 0 0 6px rgba(33,150,243,0), 0 2px 4px rgba(0,0,0,.12), 0 4px 8px rgba(0,0,0,.12) }
  `;

  const theme = createTheme({ position: "relative", right: "0px" });

  // סטייל כחול אחיד ל-CTA במניו מובייל
  const blueCtaItemSx = {
    background: "linear-gradient(135deg, #2196F3 0%, #1476D4 100%)",
    color: "white",
    borderRadius: "12px",
    mx: 0.75,
    my: 0.5,
    minHeight: 44,
    boxShadow: "0 8px 20px rgba(20,118,212,.22)",
    "& .MuiListItemIcon-root": { color: "white", minWidth: 38 },
    "&:hover": {
      background: "linear-gradient(135deg, #1E88E5 0%, #0D66C2 100%)",
      color: "white",
      transform: "translateY(-1px)",
    },
  };

  // עיצוב ויזואלי אחיד לפריטי התפריטים - ללא שינוי בהתנהגות או בניווט
  const modernMenuPaperSx = {
    mt: 1,
    minWidth: 225,
    borderRadius: "16px",
    border: "1px solid rgba(20, 91, 160, .10)",
    boxShadow: "0 18px 45px rgba(18, 61, 102, .20)",
    overflow: "hidden",
    direction: "rtl",
    "& .MuiMenu-list": { p: 1 },
    "& .MuiMenuItem-root": {
      minHeight: 44,
      borderRadius: "11px",
      px: 1.5,
      mx: 0.25,
      my: 0.25,
      fontFamily: "Assistant",
      fontWeight: 700,
      color: "#17324D",
      transition: "background-color .18s ease, transform .18s ease",
      "&:hover": {
        backgroundColor: "rgba(33,150,243,.09)",
        transform: "translateX(-2px)",
      },
    },
    "& .MuiListItemIcon-root": {
      minWidth: 38,
      color: "#218BE0",
    },
  };

  // כפתור התקנה/הורדה חכם: אנדרואיד = קישור לחנות, iOS Safari = הוראות הוספה למסך הבית
  const InstallCTA = ({ variant = "desktop" }) => {
    if (isStandalone) return null;
    const displayVal =
      variant === "desktop" ? { xs: "none", md: "inline-flex" } : "inline-flex";

    if (isAndroid) {
      return (
        <a
          href={PLAY_URL}
          target="_blank"
          rel="noopener noreferrer"
          style={{ textDecoration: "none" }}
        >
          <Button
            startIcon={<AndroidIcon />}
            variant="contained"
            sx={{
              fontFamily: "Assistant",
              textTransform: "none",
              borderRadius: "12px",
              boxShadow: "0 6px 14px rgba(0,0,0,.18)",
              backgroundColor: "white",
              color: "black",
              "&:hover": { backgroundColor: "#f0f0f0" },
              display: displayVal,
            }}
          >
            הורדה מ-Google Play
          </Button>
        </a>
      );
    }

    if (isiOSSafari) {
      return (
        <Button
          onClick={() => setOpenIOSHelp(true)}
          startIcon={<AppleIcon />}
          variant="contained"
          sx={{
            fontFamily: "Assistant",
            textTransform: "none",
            borderRadius: "12px",
            boxShadow: "0 6px 14px rgba(0,0,0,.18)",
            backgroundColor: "white",
            color: "black",
            "&:hover": { backgroundColor: "#f0f0f0" },
            display: displayVal,
          }}
        >
          הוסף למסך הבית
        </Button>
      );
    }

    return null;
  };

  return (
    <AppBar1
      sx={{
        background: "linear-gradient(135deg, #168CE5 0%, #0874C9 55%, #075FA9 100%)",
        borderBottom: "1px solid rgba(255,255,255,.18)",
        boxShadow: "0 8px 28px rgba(5, 69, 125, .22)",
        fontWeight: "bold",
        margin: 0,
        paddingTop: "env(safe-area-inset-top, 0px)",
        boxSizing: "border-box",
      }}
    >
      <StyledToolbar>
        <BoxStyled>
          <Button
            variant="text"
            sx={{
              fontFamily: `${process.env.REACT_APP_FONT}`,
              fontWeight: "bold",
              backgroundColor: "inherit",
              maxWidth: "fit-content",
              display: { md: "block", xs: "none" },
            }}
          >
            <Box sx={{ display: { md: "block", xs: "none" } }}>
              <Box>
                <a href="/" target="_self">
                  <img
                    src={logo}
                    style={{
                      maxWidth: "60px",
                      height: "60px",
                      marginTop: "5px",
                      backgroundColor: "transparent",
                      border: "none",
                      boxShadow: "none",
                      padding: "0px",
                      borderRadius: "50%",
                    }}
                    alt="Bidit logo"
                  />
                </a>
              </Box>
            </Box>
          </Button>

          <Box sx={{ display: { md: "block", xs: "none" } }}>
            <NavLink
              to="blog"
              style={{ textDecoration: "none", color: "white" }}
            >
              <Typography
                component="span"
                sx={{
                  display: "inline-flex",
                  alignItems: "center",
                  minHeight: 40,
                  px: 2,
                  borderRadius: "999px",
                  fontFamily: "Assistant",
                  fontSize: "16px",
                  fontWeight: 800,
                  letterSpacing: ".1px",
                  color: "white",
                  border: "1px solid rgba(255,255,255,.28)",
                  backgroundColor: "rgba(255,255,255,.10)",
                  transition: "background-color .18s ease, transform .18s ease",
                  "&:hover": {
                    backgroundColor: "rgba(255,255,255,.20)",
                    transform: "translateY(-1px)",
                  },
                }}
              >
                מאמרים
              </Typography>
            </NavLink>
          </Box>

          {/* CTA פרסם מכרז + כפתור התקנה/הורדה בדסקטופ + כפתור פרופיל בדסקטופ */}
          <Box
            sx={{
              display: { md: "flex", xs: "none" },
              alignItems: "center",
              gap: 1,
            }}
          >
            <NavLink to="postbid" style={{ textDecoration: "none" }}>
              <Button
                variant="outlined"
                sx={{
                  fontFamily: `${process.env.REACT_APP_FONT}`,
                  fontWeight: "bold",
                  background: "linear-gradient(135deg, #FAAF3C 0%, #F28A12 100%)",
                  color: "white",
                  margin: "0 5px",
                  borderRadius: "12px",
                  px: 2.5,
                  py: 1,
                  boxShadow: "0 6px 14px rgba(0,0,0,.18)",
                  textTransform: "none",
                  border: "1px solid rgba(255,255,255,.38)",
                  transition: "transform .18s ease, box-shadow .18s ease, filter .18s ease",
                  "&:hover": {
                    filter: "brightness(.98)",
                    transform: "translateY(-1px)",
                    boxShadow: "0 10px 22px rgba(130,72,0,.24)",
                  },
                }}
              >
                פרסם מכרז
              </Button>
            </NavLink>

            <InstallCTA variant="desktop" />

            {Cookies.get("id") && (
              <NavLink to="/profile" style={{ textDecoration: "none" }}>
                <Tooltip title="האזור האישי">
                  <IconButton
                    aria-label="האזור האישי"
                    sx={{
                      display: { xs: "none", md: "flex" },
                      width: 46,
                      height: 46,
                      backgroundColor: "white",
                      color: "#3399FF",
                      border: "2px solid #FAAF3C",
                      borderRadius: "50%",
                      boxShadow: "0 6px 14px rgba(0,0,0,.18)",
                      transition:
                        "transform .2s ease, background-color .2s ease, color .2s ease, box-shadow .2s ease",
                      "&:hover": {
                        backgroundColor: "#FAAF3C",
                        color: "white",
                        transform: "translateY(-2px) scale(1.08)",
                        boxShadow: "0 10px 20px rgba(0,0,0,.25)",
                      },
                      "&:active": {
                        transform: "scale(0.96)",
                      },
                    }}
                  >
                    <PersonRoundedIcon sx={{ fontSize: 28 }} />
                  </IconButton>
                </Tooltip>
              </NavLink>
            )}
          </Box>

          <Button
            sx={{
              fontFamily: `${process.env.REACT_APP_FONT}`,
              fontWeight: "bold",
              padding: "0px",
              margin: "0px",
              backgroundColor: "inherit",
              display: { md: "none", xs: "block" },
            }}
            id="basic-button1"
            aria-controls={open1 ? "basic-menu1" : undefined}
            aria-haspopup="true"
            aria-expanded={open1 ? "true" : undefined}
            onClick={handleClick}
          >
            <MenuIcon
              sx={{
                backgroundColor: "white",
                display: { sm: "none", xs: "block" },
              }}
            />
          </Button>
        </BoxStyled>

        {/* תפריט עליון לנייד */}
        <BoxStyled sx={{ display: { md: "none", xs: "block" } }}>
          <Tooltip title={open1 ? "סגור תפריט" : "פתח תפריט"} arrow>
            <Button
              sx={{
                minWidth: 94,
                height: 42,
                px: 1.4,
                gap: 0.7,
                borderRadius: "14px",
                backgroundColor: "rgba(255,255,255,.96)",
                color: "#1677D2",
                border: "1px solid rgba(255,255,255,.72)",
                boxShadow: "0 8px 22px rgba(0,48,96,.20)",
                fontFamily: "Assistant",
                fontWeight: 800,
                fontSize: "14px",
                textTransform: "none",
                transition: "transform .18s ease, box-shadow .18s ease, background-color .18s ease",
                "&:hover": {
                  backgroundColor: "#FFFFFF",
                  transform: "translateY(-1px)",
                  boxShadow: "0 11px 26px rgba(0,48,96,.25)",
                },
                "&:active": { transform: "scale(.97)" },
                "& .MuiSvgIcon-root": { fontSize: 21 },
              }}
              id="basic-button"
              aria-label={open1 ? "סגור תפריט" : "פתח תפריט"}
              aria-controls={open1 ? "basic-menu" : undefined}
              aria-haspopup="true"
              aria-expanded={open1 ? "true" : "false"}
              onClick={handleClick}
            >
              {open1 ? <CloseIcon /> : <MenuIcon />}
              <Box component="span">{open1 ? "סגור" : "תפריט"}</Box>
            </Button>
          </Tooltip>

          {Cookies.get("id") ? (
            <ThemeProvider theme={theme}>
              <Menu
                sx={{
                  fontFamily: `${process.env.REACT_APP_FONT}`,
                  fontWeight: "bold",
                }}
                id="basic-menu1"
                open={open1}
                onClose={handleClose}
                MenuListProps={{ "aria-labelledby": "basic-button1" }}
                anchorOrigin={{ vertical: "top", horizontal: "right" }}
                transformOrigin={{ vertical: "top", horizontal: "right" }}
                PaperProps={{ sx: modernMenuPaperSx }}
              >
                <a
                  href="/"
                  style={{ margin: 0, padding: 0, textDecoration: "none" }}
                  target="_self"
                >
                  <MenuItem onClick={handleClose}>
                    <ListItemIcon>
                      <HomeIcon fontSize="small" />
                    </ListItemIcon>
                    <span style={{ fontFamily: "Assistant" }}>בית</span>
                  </MenuItem>
                </a>

                {/* פרופיל - מובייל (מחובר) */}
                <NavLink
                  to="/profile"
                  style={{ margin: 0, padding: 0, textDecoration: "none" }}
                >
                  <MenuItem onClick={handleClose}>
                    <ListItemIcon>
                      <AccountBox fontSize="small" />
                    </ListItemIcon>
                    <span style={{ fontFamily: "Assistant" }}>האזור האישי</span>
                  </MenuItem>
                </NavLink>

                {/* פרסם מכרז - מובייל */}
                <NavLink
                  to="/postbid"
                  style={{ margin: 0, padding: 0, textDecoration: "none" }}
                >
                  <MenuItem
                    sx={{
                      mx: 0.75,
                      my: 0.75,
                      px: 1.4,
                      py: 1.15,
                      minHeight: 62,
                      borderRadius: "15px",
                      color: "#7A4500",
                      background: "linear-gradient(135deg, #FFF8EB 0%, #FFE8BD 100%)",
                      border: "1px solid rgba(250,175,60,.42)",
                      boxShadow: "0 10px 24px rgba(171,98,0,.13)",
                      "& .MuiListItemIcon-root": { minWidth: 46 },
                      "&:hover": {
                        color: "#663900",
                        background: "linear-gradient(135deg, #FFF3DB 0%, #FFDEA0 100%)",
                        transform: "translateY(-1px)",
                        boxShadow: "0 13px 28px rgba(171,98,0,.17)",
                      },
                    }}
                    onClick={handleClose}
                  >
                    <ListItemIcon>
                      <Box
                        sx={{
                          width: 38,
                          height: 38,
                          borderRadius: "12px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          color: "white",
                          background: "linear-gradient(135deg, #FAAF3C 0%, #F28A12 100%)",
                          boxShadow: "0 7px 16px rgba(242,138,18,.28)",
                        }}
                      >
                        <WorkIcon fontSize="small" />
                      </Box>
                    </ListItemIcon>
                    <Box sx={{ display: "flex", flexDirection: "column", lineHeight: 1.2 }}>
                      <Box component="span" sx={{ fontFamily: "Assistant", fontWeight: 900, fontSize: "15px" }}>
                        פרסם מכרז בחינם
                      </Box>
                      <Box component="span" sx={{ fontFamily: "Assistant", fontWeight: 600, fontSize: "12px", color: "#9A650C", mt: 0.35 }}>
                        קבל הצעות מבעלי מקצוע באזור שלך
                      </Box>
                    </Box>
                  </MenuItem>
                </NavLink>

                {/* הורדה/התקנה לפי פלטפורמה - מובייל (מחובר) */}
                {!isStandalone && (isAndroid || isiOSSafari) && (
                  <MenuItem
                    sx={blueCtaItemSx}
                    onClick={() => {
                      handleClose();
                      if (isAndroid)
                        window.open(PLAY_URL, "_blank", "noopener,noreferrer");
                      if (isiOSSafari) setOpenIOSHelp(true);
                    }}
                  >
                    <ListItemIcon>
                      {isAndroid ? (
                        <AndroidIcon fontSize="small" />
                      ) : (
                        <InstallMobileIcon fontSize="small" />
                      )}
                    </ListItemIcon>
                    <span style={{ fontFamily: "Assistant" }}>
                      {isAndroid ? "הורדה מ-Google Play" : "הוסף למסך הבית"}
                    </span>
                  </MenuItem>
                )}

                {Cookies.get("adminId") && (
                  <NavLink
                    to="/admin/home"
                    style={{ textDecoration: "none", color: "black" }}
                  >
                    <MenuItem onClick={handleClose}>
                      <ListItemIcon>
                        <AdminPanelSettings fontSize="small" />
                      </ListItemIcon>
                      <span style={{ fontFamily: "Assistant" }}>
                        מנהל מערכת
                      </span>
                    </MenuItem>
                  </NavLink>
                )}

                <NavLink
                  to="/mybids"
                  style={{ textDecoration: "none", color: "black" }}
                >
                  <MenuItem onClick={handleClose}>
                    <ListItemIcon>
                      <Work fontSize="small" />
                    </ListItemIcon>
                    <span style={{ fontFamily: "Assistant" }}>המכרזים שלי</span>
                  </MenuItem>
                </NavLink>

                <NavLink
                  to="/signin"
                  style={{ textDecoration: "none", color: "black" }}
                >
                  <MenuItem
                    onClick={() => {
                      Cookies.set("subscription", "No", { expires: 365 });
                      Cookies.remove("favids");
                      Cookies.remove("token");
                      Cookies.remove("name");
                      Cookies.remove("last_name");
                      Cookies.remove("id");
                      Cookies.remove("username");
                      Cookies.remove("email");
                      Cookies.remove("phone");
                      Cookies.remove("adminId");
                      Cookies.remove("admintoken");
                      clearLocalStorageExcept(PRESERVE_LOCAL_KEYS);
                      handleClose();
                    }}
                  >
                    <ListItemIcon>
                      <Logout fontSize="small" />
                    </ListItemIcon>
                    <span style={{ fontFamily: "Assistant" }}>התנתק</span>
                  </MenuItem>
                </NavLink>
              </Menu>
            </ThemeProvider>
          ) : (
            <Menu
              id="basic-menu1"
              MenuListProps={{ "aria-labelledby": "basic-button1" }}
              open={open1}
              onClose={handleClose}
              anchorOrigin={{ vertical: "top", horizontal: "right" }}
              transformOrigin={{ vertical: "top", horizontal: "right" }}
              PaperProps={{ sx: modernMenuPaperSx }}
            >
              <NavLink
                to="/signin"
                style={{ margin: 0, padding: 0, textDecoration: "none" }}
              >
                <MenuItem onClick={handleClose}>
                  <ListItemIcon>
                    <Login fontSize="small" />
                  </ListItemIcon>
                  <span>התחבר</span>
                </MenuItem>
              </NavLink>

              {/* התקנה/הורדה גם לאורחים - מובייל (לא מחובר) */}
              {!isStandalone && (isAndroid || isiOSSafari) && (
                <MenuItem
                  sx={blueCtaItemSx}
                  onClick={() => {
                    handleClose();
                    if (isAndroid)
                      window.open(PLAY_URL, "_blank", "noopener,noreferrer");
                    if (isiOSSafari) setOpenIOSHelp(true);
                  }}
                >
                  <ListItemIcon>
                    {isAndroid ? (
                      <AndroidIcon fontSize="small" />
                    ) : (
                      <InstallMobileIcon fontSize="small" />
                    )}
                  </ListItemIcon>
                  <span>
                    {isAndroid ? "הורדה מ-Google Play" : "הוסף למסך הבית"}
                  </span>
                </MenuItem>
              )}

              <NavLink
                to="/userlandingpage"
                style={{ margin: 0, padding: 0, textDecoration: "none" }}
              >
                <MenuItem onClick={handleClose}>
                  <ListItemIcon>
                    <PersonOutline fontSize="small" />
                  </ListItemIcon>
                  <span>הרשמה ללקוחות</span>
                </MenuItem>
              </NavLink>

              <NavLink
                to="/proflandingpage"
                style={{ margin: 0, padding: 0, textDecoration: "none" }}
              >
                <MenuItem onClick={handleClose}>
                  <ListItemIcon>
                    <HandymanOutlined fontSize="small" />
                  </ListItemIcon>
                  <span>הרשמה לבעלי מקצוע</span>
                </MenuItem>
              </NavLink>
            </Menu>
          )}
        </BoxStyled>

        {/* אייקון בית לנייד */}
        <Stack
          sx={{
            display: { xs: "flex", md: "none" },
            alignItems: "center",
            justifyContent: "center",
            flexShrink: 0,
          }}
        >
          <a href="/" target="_self" style={{ textDecoration: "none" }}>
            <Tooltip title="מסך הבית" arrow>
              <IconButton
                aria-label="מסך הבית"
                sx={{
                  width: 44,
                  height: 44,
                  p: 0,
                  borderRadius: "14px",
                  color: "#1677D2",
                  backgroundColor: "rgba(255,255,255,.96)",
                  border: "1px solid rgba(255,255,255,.72)",
                  boxShadow: "0 8px 22px rgba(0,48,96,.20)",
                  transition: "transform .18s ease, box-shadow .18s ease, background-color .18s ease",
                  "&:hover": {
                    backgroundColor: "#FFFFFF",
                    transform: "translateY(-1px)",
                    boxShadow: "0 11px 26px rgba(0,48,96,.25)",
                  },
                  "&:active": { transform: "scale(.96)" },
                }}
              >
                <HomeIcon sx={{ fontSize: 23 }} />
              </IconButton>
            </Tooltip>
          </a>
        </Stack>

        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexShrink: 0,
            minWidth: 44,
          }}
        >
          {Cookies.get("id") && (
            <PositionedMenu
              setNotifications={setNotifications}
              notifications={notifications}
              badgeContent={badgeContent}
              setBadgeContent={setBadgeContent}
            />
          )}
          {/* כפתור התקנה/הורדה בדסקטופ ליד האווטאר */}
          <InstallCTA variant="desktop" />
        </Box>

        {/* טקסט ל-SEO */}
        <Typography
          variant={isBlogPage ? "div" : "h1"}
          sx={{
            flexShrink: 1,
            minWidth: 0,
            textAlign: "center",
            fontFamily: "Assistant",
            fontSize: { xs: "15px", sm: "18px", md: "20px" },
            fontWeight: 800,
            lineHeight: 1.2,
            letterSpacing: "-.2px",
            color: "#FFFFFF",
            textShadow: "0 2px 12px rgba(0, 39, 78, .28)",
            px: { xs: 0.5, sm: 1.5 },
            py: 0.75,
            borderRadius: "14px",
            backgroundColor: {
              xs: "transparent",
              md: "rgba(255,255,255,.08)",
            },
            border: {
              xs: "none",
              md: "1px solid rgba(255,255,255,.14)",
            },
            whiteSpace: { xs: "normal", sm: "nowrap" },
          }}
        >
          <Box component="span" sx={{ fontWeight: 900 }}>
            בידאיט
          </Box>{" "}
          <Box
            component="span"
            sx={{ color: "#FFE0A8", fontWeight: 700 }}
          >
            פשוט למצוא בעל מקצוע
          </Box>
        </Typography>

        <BoxStyled>
          {showResult && <Navigate to={"/" + String(search1)} />}
          {Cookies.get("id") ? (
            <Avatar
              onClick={() => setOpen(true)}
              aria-label="פתיחת תפריט המשתמש"
              sx={{
                display: { md: "flex", xs: "none" },
                alignItems: "center",
                justifyContent: "center",
                width: 48,
                height: 48,
                cursor: "pointer",
                color: "#FFFFFF",
                background:
                  "linear-gradient(135deg, #1677D2 0%, #0B5FA8 58%, #FAAF3C 100%)",
                border: "2px solid rgba(255,255,255,.96)",
                outline: "2px solid rgba(250,175,60,.72)",
                boxShadow:
                  "0 8px 20px rgba(0,48,96,.24), 0 2px 6px rgba(0,0,0,.12)",
                transition:
                  "transform .18s ease, box-shadow .18s ease, filter .18s ease",
                "&:hover": {
                  transform: "translateY(-2px) scale(1.04)",
                  filter: "brightness(1.04)",
                  boxShadow:
                    "0 12px 26px rgba(0,48,96,.30), 0 4px 10px rgba(0,0,0,.14)",
                },
                "&:active": {
                  transform: "scale(.97)",
                },
              }}
            >
              <Typography
                component="span"
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: "100%",
                  height: "100%",
                  fontFamily: "Assistant",
                  fontSize: "20px",
                  fontWeight: 900,
                  lineHeight: 1,
                  textShadow: "0 1px 3px rgba(0,0,0,.18)",
                }}
              >
                {Cookies.get("name")
                  ? Cookies.get("name").charAt(0)
                  : "" + Cookies.get("last_name")
                    ? Cookies.get("last_name").charAt(0)
                    : ""}
              </Typography>
            </Avatar>
          ) : (
            <NavLink to="/signin" style={{ textDecoration: "none" }}>
              <Button
                variant="contained"
                sx={{
                  fontFamily: "Assistant",
                  backgroundColor: "rgba(255,255,255,.96)",
                  color: "#116FB8",
                  borderRadius: "12px",
                  px: 2,
                  minHeight: 42,
                  fontWeight: 800,
                  boxShadow: "0 6px 16px rgba(0,45,86,.16)",
                  textTransform: "none",
                  display: { xs: "none", md: "block" },
                  "&:hover": { backgroundColor: "white", transform: "translateY(-1px)" },
                }}
              >
                <span style={{ fontFamily: "Assistant" }}>התחבר</span>
              </Button>
            </NavLink>
          )}
          {!Cookies.get("id") && (
            <NavLink to="/userlandingpage" style={{ textDecoration: "none" }}>
              <Button
                sx={{
                  fontFamily: "Assistant",
                  backgroundColor: "rgba(255,255,255,.96)",
                  color: "#116FB8",
                  borderRadius: "12px",
                  px: 2,
                  minHeight: 42,
                  fontWeight: 800,
                  boxShadow: "0 6px 16px rgba(0,45,86,.16)",
                  textTransform: "none",
                  display: { xs: "none", md: "block" },
                  "&:hover": { backgroundColor: "white", transform: "translateY(-1px)" },
                }}
                variant="contained"
              >
                <span style={{ fontFamily: "Assistant" }}> הרשמה ללקוחות</span>
              </Button>
            </NavLink>
          )}
          {!Cookies.get("id") && (
            <NavLink to="/proflandingpage" style={{ textDecoration: "none" }}>
              <Button
                sx={{
                  fontFamily: "Assistant",
                  backgroundColor: "rgba(255,255,255,.96)",
                  color: "#116FB8",
                  borderRadius: "12px",
                  px: 2,
                  minHeight: 42,
                  fontWeight: 800,
                  boxShadow: "0 6px 16px rgba(0,45,86,.16)",
                  textTransform: "none",
                  display: { xs: "none", md: "block" },
                  "&:hover": { backgroundColor: "white", transform: "translateY(-1px)" },
                }}
                variant="contained"
              >
                <span style={{ fontFamily: "Assistant" }}>
                  {" "}
                  הרשמה לבעלי מקצוע
                </span>
              </Button>
            </NavLink>
          )}
        </BoxStyled>

        <UserBox></UserBox>
      </StyledToolbar>

      {/* כפתורי הרשמה גלויים בדף הבית במובייל למשתמש שאינו מחובר */}
      {isHomePage && !Cookies.get("id") && (
        <Box
          component="nav"
          aria-label="אפשרויות הרשמה"
          sx={{
            display: { xs: "grid", md: "none" },
            gridTemplateColumns: "1fr 1fr",
            gap: 1,
            width: "100%",
            px: 1.25,
            pb: 1.25,
            boxSizing: "border-box",
          }}
        >
          <NavLink to="/userlandingpage" style={{ textDecoration: "none" }}>
            <Button
              fullWidth
              variant="contained"
              startIcon={<PersonOutline />}
              sx={{
                minHeight: 46,
                borderRadius: "13px",
                backgroundColor: "#FFFFFF",
                color: "#116FB8",
                border: "1px solid rgba(255,255,255,.82)",
                boxShadow: "0 7px 18px rgba(0,45,86,.18)",
                fontFamily: "Assistant",
                fontSize: { xs: "12.5px", sm: "15px" },
                fontWeight: 900,
                lineHeight: 1.2,
                textTransform: "none",
                whiteSpace: "nowrap",
                "& .MuiButton-startIcon": { ml: 0.6, mr: 0 },
                "&:hover": { backgroundColor: "#F4FAFF" },
              }}
            >
              הרשמה ללקוחות
            </Button>
          </NavLink>

          <NavLink to="/proflandingpage" style={{ textDecoration: "none" }}>
            <Button
              fullWidth
              variant="contained"
              startIcon={<HandymanOutlined />}
              sx={{
                minHeight: 46,
                borderRadius: "13px",
                background: "linear-gradient(135deg, #FAAF3C 0%, #F28A12 100%)",
                color: "#FFFFFF",
                border: "1px solid rgba(255,255,255,.55)",
                boxShadow: "0 7px 18px rgba(120,65,0,.22)",
                fontFamily: "Assistant",
                fontSize: { xs: "12.5px", sm: "15px" },
                fontWeight: 900,
                lineHeight: 1.2,
                textTransform: "none",
                whiteSpace: "nowrap",
                "& .MuiButton-startIcon": { ml: 0.6, mr: 0 },
                "&:hover": {
                  background: "linear-gradient(135deg, #F5A42C 0%, #E77D08 100%)",
                },
              }}
            >
              הרשמה לבעלי מקצוע
            </Button>
          </NavLink>
        </Box>
      )}

      {/* תפריט אווטאר */}
      <Menu
        id="basic-menu"
        open={open}
        onClose={() => setOpen(false)}
        MenuListProps={{ "aria-labelledby": "basic-button" }}
        anchorOrigin={{ vertical: "top", horizontal: "left" }}
        transformOrigin={{ vertical: "top", horizontal: "left" }}
        PaperProps={{ sx: modernMenuPaperSx }}
      >
        <NavLink to="/profile" style={{ textDecoration: "none" }}>
          <MenuItem
            sx={{
              fontFamily: `${process.env.REACT_APP_FONT}`,
              fontWeight: "bold",
            }}
          >
            <ListItemIcon><AccountBox fontSize="small" /></ListItemIcon>
            האזור האישי
          </MenuItem>
        </NavLink>

        <NavLink
          to="/mybids"
          style={{ textDecoration: "none", color: "black" }}
        >
          <MenuItem
            onClick={handleClose}
            sx={{
              fontFamily: `${process.env.REACT_APP_FONT}`,
              fontWeight: "bold",
            }}
          >
            <ListItemIcon><Work fontSize="small" /></ListItemIcon>
            <span style={{ fontFamily: "Assistant" }}>המכרזים שלי</span>
          </MenuItem>
        </NavLink>

        {Cookies.get("adminId") && (
          <NavLink
            to="/admin/home"
            style={{ textDecoration: "none", color: "black" }}
          >
            <MenuItem
              onClick={handleClose}
              sx={{
                fontFamily: `${process.env.REACT_APP_FONT}`,
                fontWeight: "bold",
              }}
            >
              <ListItemIcon><AdminPanelSettings fontSize="small" /></ListItemIcon>
              <span style={{ fontFamily: "Assistant" }}>מנהל מערכת</span>
            </MenuItem>
          </NavLink>
        )}

        <NavLink
          to="/signin"
          style={{ textDecoration: "none", color: "black" }}
        >
          <MenuItem
            sx={{
              fontFamily: `${process.env.REACT_APP_FONT}`,
              fontWeight: "bold",
            }}
            onClick={() => {
              Cookies.set("subscription", "No", { expires: 365 });
              Cookies.remove("favids");
              Cookies.remove("token");
              Cookies.remove("name");
              Cookies.remove("last_name");
              Cookies.remove("id");
              Cookies.remove("username");
              Cookies.remove("email");
              Cookies.remove("phone");
              Cookies.remove("adminId");
              Cookies.remove("admintoken");
              clearLocalStorageExcept(PRESERVE_LOCAL_KEYS);
              handleClose();
            }}
          >
            <ListItemIcon sx={{ color: "#D14343 !important" }}><Logout fontSize="small" /></ListItemIcon>
            <Box component="span" sx={{ color: "#B73333" }}>התנתק</Box>
          </MenuItem>
        </NavLink>
      </Menu>

      {/* דיאלוג עזרה ל-iOS */}
      <Dialog open={openIOSHelp} onClose={() => setOpenIOSHelp(false)}>
        <DialogTitle sx={{ fontFamily: "Assistant", fontWeight: "bold" }}>
          הוספת האפליקציה למסך הבית
        </DialogTitle>
        <DialogContent sx={{ fontFamily: "Assistant", lineHeight: 1.6 }}>
          <div>
            <p>באייפון עם Safari:</p>
            <ol style={{ paddingInlineStart: 18 }}>
              <li>פתח את האתר ב-Safari.</li>
              <li>לחץ על כפתור השיתוף בתחתית.</li>
              <li>בחר "הוסף למסך הבית".</li>
              <li>אשר בשם ברירת המחדל.</li>
            </ol>
            <p>לאחר מכן תראה אייקון של Bidit במסך הבית כמו אפליקציה.</p>
          </div>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => setOpenIOSHelp(false)}
            sx={{ fontFamily: "Assistant" }}
          >
            סגור
          </Button>
        </DialogActions>
      </Dialog>
    </AppBar1>
  );
}

export default Navbar;
